import { jsxs, jsx } from 'react/jsx-runtime';
import { i as EGDSLayoutFlex, j as EGDSLayoutFlexItem } from '../layout-flex-item/index-chunk.esm.js';
import { c as classNames } from '../index_orig/index-chunk.esm.js';
import styles from '../styles/uitk-egds-progress-bar.css';

const getClassNameList = classNames.bind(styles);
const EGDSProgressBar = (props) => {
    const { percent, progressDescription, title, accessibilityLabel, theme } = props;
    const barFillStyle = {
        // eslint-disable-next-line capitalized-comments
        width: `${Math.max(0, percent)}%`, // stylelint-disable
    };
    const baseClassName = 'uitk-progress-bar';
    const progressBarFillClassNames = getClassNameList(`${baseClassName}-fill`, theme && `${baseClassName}-${theme}`);
    return (jsxs("div", { className: getClassNameList(baseClassName), children: [jsxs(EGDSLayoutFlex, { space: "three", justifyContent: "space-between", children: [accessibilityLabel && (jsx("span", { className: getClassNameList('is-visually-hidden', `${baseClassName}-a11y-label`), children: `${accessibilityLabel}" "` })), jsx(EGDSLayoutFlexItem, { className: getClassNameList(`${baseClassName}-label`), grow: 1, children: jsx("div", { "aria-hidden": Boolean(accessibilityLabel), children: title }) }), jsx(EGDSLayoutFlexItem, { className: getClassNameList(`${baseClassName}-value`), alignSelf: "end", children: jsx("div", { "aria-hidden": Boolean(accessibilityLabel), children: progressDescription }) })] }), jsxs("div", { className: getClassNameList(`${baseClassName}-track`), children: [!accessibilityLabel && (jsx("span", { className: getClassNameList('is-visually-hidden'), children: `${`" "`}${title} ${barFillStyle.width}` })), jsx("div", { className: progressBarFillClassNames, style: barFillStyle })] })] }));
};
EGDSProgressBar.defaultProps = {
    theme: 'standard',
};
EGDSProgressBar.displayName = 'EGDSProgressBar';

export { EGDSProgressBar as E };
//# sourceMappingURL=index-chunk.esm.js.map
